import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import { QrCode, X } from 'lucide-react';

const QR_CODE_IMAGE = "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/y69bjvrb_Screenshot%202026-01-16%20at%2010.09.44%E2%80%AFAM.png";

export const CashlessPayment = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      {/* Expanded QR Code Modal */}
      {isExpanded && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 bg-foreground/40 backdrop-blur-sm z-[60]"
            onClick={() => setIsExpanded(false)}
          />
          
          {/* Modal - Centered */}
          <div 
            className={cn(
              "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[70]",
              "bg-card border border-border rounded-lg shadow-elevated",
              "overflow-hidden animate-scale-in"
            )}
          >
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-4 border-b border-border bg-background-subtle">
              <span className="text-base font-medium text-foreground">Cashless Payment</span>
              <button
                onClick={() => setIsExpanded(false)}
                className="p-1.5 hover:bg-secondary rounded-full transition-colors"
                aria-label="Close"
              >
                <X className="w-5 h-5 text-muted-foreground" />
              </button>
            </div>
            
            {/* QR Codes */}
            <div className="p-6">
              <img
                src={QR_CODE_IMAGE}
                alt="Venmo and CashApp QR codes"
                className="w-72 h-auto rounded-sm"
              />
              <p className="text-sm text-muted-foreground text-center mt-4">
                Scan to pay with Venmo or CashApp
              </p>
            </div>
          </div>
        </>
      )}
      
      {/* Toggle Button - Fixed Bottom Left */}
      <div className="fixed bottom-6 left-6 z-[55]">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={cn(
            "flex items-center gap-2 px-4 py-3",
            "bg-card border border-border rounded-full shadow-card",
            "hover:shadow-elevated hover:border-slate-muted transition-all duration-smooth",
            "focus-gallery",
            isExpanded && "bg-secondary"
          )}
          aria-label="Cashless payment options"
          aria-expanded={isExpanded}
        >
          <QrCode className="w-5 h-5 text-foreground" strokeWidth={1.5} />
          <span className="text-sm font-medium text-foreground hidden sm:inline">
            Venmo / CashApp
          </span>
        </button>
      </div>
    </>
  );
};

export default CashlessPayment;
